module.exports = __webpack_public_path__ + "fonts/Satoshi-Black.3da7f09.woff2";